import { render, staticRenderFns } from "./RatingFieldPreview.vue?vue&type=template&id=23c6b9ca&scoped=true"
import script from "./RatingFieldPreview.vue?vue&type=script&lang=js"
export * from "./RatingFieldPreview.vue?vue&type=script&lang=js"
import style0 from "./RatingFieldPreview.vue?vue&type=style&index=0&id=23c6b9ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c6b9ca",
  null
  
)

export default component.exports